import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { Web3OnboardProvider, init } from "@web3-onboard/react";
import injectedModule from "@web3-onboard/injected-wallets";
import walletConnectModule from "@web3-onboard/walletconnect";
import { AppProvider } from "./AppProvider";


const wcInitOptions = {
  projectId: "d51c28bf5c14789d90946e35be2dab5a", //wallet connect ID
  requiredChains: [1, 137, 56, 5424],
  optionalChains: [11155111, 80001, 97, 1995],
  dappUrl: "https://edxconnect.edexa.network",
};

const accountCenter = {
  desktop: {
    minimal: false,
    enabled: false,
  },
  mobile: {
    enabled: false,
    minimal: true,
  },
};

const connect = {
  autoConnectLastWallet: true,
};

const injected = injectedModule();
const walletConnect = walletConnectModule(wcInitOptions);

const web3Onboard = init({
  wallets: [injected, walletConnect],
  chains: [
    {
      id: 1,
      token: 'ETH',
      label: 'Ethereum',
      rpcUrl: "https://ethereum-rpc.publicnode.com",
      icon: "https://etherscan.io/images/svg/brands/ethereum-original.svg",
      blockExplorerUrl: "https://etherscan.io/",
    },
    {
      id: 137,
      token: 'MATIC',
      label: 'Polygon',
      rpcUrl: "https://polygon-bor-rpc.publicnode.com",
      icon: "https://amoy.polygonscan.com/assets/poly/images/svg/logos/chain-light.svg?v=24.7.4.1",
      blockExplorerUrl: "https://polygonscan.com/",
    },
    {
      id: 56,
      token: 'BNB',
      label: 'Binance Smart Chain',
      rpcUrl: 'https://bsc-rpc.publicnode.com',
      icon: "https://bscscan.com/assets/bsc/images/svg/logos/token-light.svg?v=24.8.1.0",
      blockExplorerUrl: "https://bscscan.com/",
    },
    {
      id: 5424,
      token: 'EDX',
      label: 'edeXa',
      rpcUrl: "https://rpc.edexa.network",
      icon: "https://edexa.network/static/media/logo.png",
      blockExplorerUrl: "https://explorer.edexa.network/",
    }
  ],
  accountCenter,
  connect,
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Web3OnboardProvider web3Onboard={web3Onboard}>
      <div
        className="h-svh"
        style={{ overflow: "scroll", scrollbarWidth: "none" }}
      >
        <AppProvider>
          <App />
        </AppProvider>
      </div>
    </Web3OnboardProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
